import { render, staticRenderFns } from "./ProfileGigSection.vue?vue&type=template&id=e1495630&scoped=true&"
import script from "./ProfileGigSection.vue?vue&type=script&lang=js&"
export * from "./ProfileGigSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGigSection.vue?vue&type=style&index=0&id=e1495630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1495630",
  null
  
)

export default component.exports